import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import ContentWrapper from "../../../../components/common/ContentWrapper.js";
import Card from "../../../../components/common/Card.js";
import Col from "react-bootstrap/Col";
import CardHeader from "../../../../components/common/CardHeader.js";
import CardBody from "../../../../components/common/CardBody.js";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FormGroup from "../../../../components/common/form/FormGroup.js";
import Row from "react-bootstrap/Row";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Checkbox
} from "@mui/material";
import MaterialCustomTablePagination from "../../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import { history } from "../../../../helper/history.js";
import { PaperService } from "../../../../service/manage/paper/paper_service.js";
import {
  sweetAlertEnroll,
  sweetStatusAlert
} from "../../../../components/common/SweetAlert.js";
import PageSpinner from "../../../../components/common/spinner/PageSpinner.js";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import { StudentService } from "../../../../service/manage/registration/student.service.js";
import { EnrolledPaperService } from "../../../../service/manage/paper/enrolled_paper.service.js";
import { Button } from "react-bootstrap";
import Chip from "@mui/material/Chip";
import { assessmentService } from "../../../../service/assessment/assessmentService.js";
import { CMC_ASSESSMENT_FILTERS } from "../../../../helper/constants.js";
import { CreditService } from "../../../../service/manage/subscription/credit.service.js";
import TimeZoneHandler from "../../../../handlers/TimeZoneHandler.js";
import config from "../../../../helper/config.js";
import { customerConstants } from "../../../../helper/constants.js";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import moment from "moment";
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import Typography from '@mui/material/Typography';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { Radio, Sheet } from '@mui/joy';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import { Box, CircularProgress, IconButton } from "@mui/material";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FormControlLabel from "@mui/material/FormControlLabel";
import PaperListChips from "../../../manage/paper/edsider/FindPaperTabs/PaperListChips.js";
import ClearIcon from '@mui/icons-material/Clear'

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle, gradeText;
const customer = getCustomerFeatureFlag()
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    gradeText = "Grade";
    break;
  case customerConstants.EXO_CUSTOMER2:
    gradeText = "Year";
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent"
    }
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent"
    }
    break;
  default:
    gradeText = "Grade";
    break;
}

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

export default class PaperList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userType: null,
      userId: "",
      node_mid: null,
      papers: [],
      enrolledPapers: [],
      limit: 10,
      offset: 0,
      search_term: "",
      breadcrumb2: null,
      nodeTitle: null,
      totalPapers: 25,
      currentPage: 0,
      sortColumn: "assess_name",
      sortDirection: "desc",
      selectedStudent: "",
      studentlist: [],
      isTableDataLoading: true,
      isSpinnerLoading: false,
      isDropHidden: false,
      assessment_name: "",
      editVisibility: false,
      addVisibility: false,
      deleteVisibility: false,
      viewVisibility: false,
      create_user_id: "",
      create_user_table_id: "",
      filterValues: [],
      filters: [],
      selectedFilters: [],
      selectedGrades: null,
      selectedChapters: null,
      selectedSubjects: null,
      selectedAuthors: null,
      selectedYears: null,
      selectedCategories: null,
      selectedTerms: null,
      selectedDifficulties: null,
      selectedLanguages: null,
      selectedExamCategories: null,
      selectedTeachers: null,
      selectedCreators: null,
      selectedStartDate: null,
      selectedEndDate: null,
      allCategories: [],
      allLanguages: [],
      allSubjects: [],
      allAuthors: [],
      allYears: [],
      allDifficulties: [],
      allGrades: [],
      allTerms: [],
      allChapters: [],
      allExamCategories: [],
      allCreators: [],
      allSources: [],
      showInsertModal: false,
      credits: [],
      credit_id: "",
      selectedCredit: null,
      isCreditNotAvailable: false,
      isModified: false,
      asses_id: null,
      assess_name: null,
      grade_id: '',
      is_level_price_loading: false,
      creditsLoading: false,
      selectedPaper: false,
      gradeCounts: [],
      subjectCounts: [],
      languageCounts: [],
      examCategoryCounts: [],
      sourceCounts: [],
      authorCounts: [],
      createdByCounts: [],
      categoryCounts: [],
      difficultyCounts: [],
      chapterCounts: [],
      yearCounts: [],
      termCounts: [],
      statusCounts: [],
    };

    this.debouncedHandleSearch = debounce(this.callAfterSubmit, 2000);
  }

  componentDidMount() {
    const {
      lg_user_id,
      lg_user_table_id,
      flg_list_active,
      privilage_view,
      privilege_add,
      privilege_edit,
      nodeTitle,
      breadcrumb2,
      privilege_delete,
    } = this.props.state;

    this.getVisibilityCheck(
      privilage_view,
      privilege_add,
      privilege_delete,
      privilege_edit
    );
    this.setState({
      breadcrumb2: breadcrumb2,
      nodeTitle: nodeTitle,
    });
    let userType = sessionStorage.getItem("userType");
    this.setState({ userType });

    if (userType === "admin") {
      if (flg_list_active === 1) {
        this.setState({ isDropHidden: true });
      }
      this.fetchAllpapers();
      this.fetchallstudent();
    }

    if (userType === "student") {
      if (flg_list_active === null) {
        StudentService.getCreateUserDetail(
          lg_user_id,
          lg_user_table_id,
          userType
        ).then((response) => {
          const create_user_id = response.data.user_detail[0].create_user_id;
          const create_user_table_id =
            response.data.user_detail[0].create_user_table_id;
          this.setState({
            create_user_id: create_user_id,
            create_user_table_id: create_user_table_id,
            isDropHidden: false,
          });
        });
      }
      this.fetchAllpapers();
      this.fetchAllEnrolledChildPapers();
    }

    if (userType === "parent") {
      if (flg_list_active === 1) {
        this.setState({ isDropHidden: true });
      }
      this.fetchAllpapers();
      this.fetchallstudent();
    }
    this.fetchAllAssessmentSettings();
  }

  getVisibilityCheck(
    privilage_view,
    privilege_add,
    privilege_delete,
    privilege_edit
  ) {
    if (privilege_add === 1) {
      this.setState({
        addVisibility: true,
      });
    } else if (privilege_edit === 1) {
      this.setState({
        editVisibility: true,
      });
    } else if (privilage_view === 1) {
      this.setState({
        viewVisibility: true,
      });
    } else if (privilege_delete === 1) {
      this.setState({
        deleteVisibility: true,
      });
    }
  }

  fetchAllAssessmentSettings() {
    this.setState({
      isLoading: true
    });

    const fetchAssessmentMetaData = assessmentService.getAllAssessmentMetaData();

    Promise.all([
      fetchAssessmentMetaData
    ])
      .then((response) => {
        const [
          assessmentMetaDataResponse
        ] = response;

        this.setState({
          allCategories: assessmentMetaDataResponse.data.find(item => 'categories' in item).categories,
          allLanguages: assessmentMetaDataResponse.data.find(item => 'languages' in item).languages,
          allSubjects: assessmentMetaDataResponse.data.find(item => 'subjects' in item).subjects,
          allAuthors: assessmentMetaDataResponse.data.find(item => 'authors' in item).authors,
          allYears: assessmentMetaDataResponse.data.find(item => 'years' in item).years,
          allDifficulties: assessmentMetaDataResponse.data.find(item => 'difficulty_types' in item).difficulty_types,
          allGrades: assessmentMetaDataResponse.data.find(item => 'grades' in item).grades,
          allTerms: assessmentMetaDataResponse.data.find(item => 'terms' in item).terms,
          allChapters: assessmentMetaDataResponse.data.find(item => 'chapters' in item).chapters,
          allExamCategories: assessmentMetaDataResponse.data.find((item) => "exam_categories" in item).exam_categories,
          allCreators: assessmentMetaDataResponse.data.find((item) => "creators" in item).creators,
          allSources: assessmentMetaDataResponse.data.find((item) => "sources" in item).sources,
          allAssessmentStatuses: assessmentMetaDataResponse.data.find((item) => "statuses" in item).statuses,
          isLoading: false
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
      });
  }

  getPaperCategory(category_id) {
    if (category_id !== null) {
      const category = this.state.allCategories?.find(
        (category) => category.category_id == category_id
      );
      return category?.name;
    }
    else {
      return "N/A";
    }
  }

  getPaperExamCategory(exam_category_id) {
    if (exam_category_id !== null) {
      const exam_category = this.state.allExamCategories?.find(
        (exam_category) => exam_category.exam_category_id == exam_category_id
      );
      return exam_category?.name;
    }
    else {
      return "N/A";
    }
  }

  getPaperSource(source_id) {
    if (source_id !== null) {
      const source = this.state.allSources?.find(
        (source) => source.source_id == parseInt(source_id)
      );
      return source?.source;
    }
    else {
      return "N/A";
    }
  }

  getPaperLanguage(language_id) {
    if (language_id !== null) {
      const language = this.state.allLanguages?.find(
        (language) => language.language_id == language_id
      );
      return language?.language;
    }
    else {
      return "N/A";
    }
  }

  getPaperSubject(subject_id) {
    if (subject_id !== null) {
      const subject = this.state.allSubjects?.find(
        (subject) => subject.subject_id == subject_id
      );
      return subject?.subject;
    }
    else {
      return "N/A";
    }
  }

  getPaperAuthor(author_id) {
    if (author_id !== null) {
      const author = this.state.allAuthors?.find(
        (author) => author.author_id == author_id
      );
      return author?.author;
    }
    else {
      return "N/A";
    }
  }

  getPaperYear(year_id) {
    if (year_id !== null) {
      const year = this.state.allYears?.find(
        (year) => year.year_id == year_id
      );
      return year?.year;
    }
    else {
      return "N/A";
    }
  }

  getPaperDifficulty(difficulty_id) {
    if (difficulty_id !== null) {
      const difficulty = this.state.allDifficulties?.find(
        (difficulty) => difficulty.difficulty_id == difficulty_id
      );
      return difficulty?.difficulty_type;
    }
    else {
      return "N/A";
    }
  }

  getPaperGrade(grade_id) {
    if (grade_id !== null) {
      const grade = this.state.allGrades?.find(
        (grade) => grade.grade_id == grade_id
      );
      return grade?.grade;
    }
    else {
      return "N/A";
    }
  }

  getPaperTerm(term_id) {
    if (term_id !== null) {
      const term = this.state.allTerms?.find(
        (term) => term.term_id == term_id
      );
      return term?.term;
    }
    else {
      return "N/A";
    }
  }

  getPaperChapter(chapter_id) {
    if (chapter_id !== null) {
      const chapter = this.state.allChapters?.find(
        (chapter) => chapter.chapter_id == chapter_id
      );
      return chapter?.chapter;
    }
    else {
      return "N/A";
    }
  }

  getCreatedAtLocal(time) {
    if (time != null) {
      let timeStamp = new Date(time.concat("Z"))
      let d = new Date(timeStamp)
      // let startDate = d.toDateString();
      // let startTime = d.toLocaleTimeString('en-SL');
      let local = moment(timeStamp).local().format("MMMM Do YYYY hh:mm A")
      return local;
    }
    else {
      return "N/A";
    }
  }

  callAfterSubmit() {
    this.fetchAllpapers();
    this.fetchEnrollPaperData();
    // this.fetchAllAssessmentSettings();
  }

  fetchAllpapers = () => {
    this.setState({ isTableDataLoading: true });
    const {
      limit,
      offset,
      sortColumn,
      sortDirection,
      search_term,
      selectedCategories,
      selectedAuthors,
      selectedChapters,
      selectedDifficulties,
      selectedGrades,
      selectedLanguages,
      selectedTerms,
      selectedYears,
      selectedSubjects,
      selectedExamCategories,
      selectedTeachers,
      selectedCreators,
      selectedStartDate,
      selectedEndDate,
    } = this.state;
    let node_mid = this.props.state.mid;

    PaperService.getfilterdAllAssesments(
      node_mid,
      limit,
      offset,
      sortColumn,
      sortDirection,
      search_term,
      selectedCategories,
      selectedAuthors,
      selectedChapters,
      selectedGrades,
      selectedDifficulties,
      selectedLanguages,
      selectedTerms,
      selectedYears,
      selectedSubjects,
      selectedExamCategories,
      selectedTeachers,
      selectedCreators,
      selectedStartDate,
      selectedEndDate,
    )
      .then((response) => {
        if (response.success) {
          this.setState({
            papers: response.data.papers,
            totalPapers: response.data.count,
            isTableDataLoading: false,
            gradeCounts: response.data.grade_counts,
            subjectCounts: response.data.subject_counts,
            languageCounts: response.data.language_counts,
            examCategoryCounts: response.data.exam_category_counts,
            sourceCounts: response.data.source_counts,
            authorCounts: response.data.author_counts,
            categoryCounts: response.data.category_counts,
            difficultyCounts: response.data.difficulty_counts,
            chapterCounts: response.data.chapter_counts,
            yearCounts: response.data.year_counts,
            termCounts: response.data.term_counts,
            statusCounts: response.data.status_counts,
            createdByCounts: response.data.created_by_counts,
          });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching students. Please refresh the screen!",
            "error"
          );
        }
      })
      .catch((error) => {
        sweetStatusAlert(
          "Failed!",
          "Error fetching students. Please refresh the screen!",
          "error"
        );
      })
      .finally(() => {
        this.setState({ isTableDataLoading: false });
      });
  };

  handleViewClick = (e, paper) => {
    e.preventDefault();
    this.setState({
      selectedPaper: paper,
      showDetailModal: true,
    });
  };

  toggleDetailModal = () => {
    this.setState((prevState) => ({
      showDetailModal: !prevState.showDetailModal,
    }));
  };

  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.callAfterSubmit();
      }
    );
  };

  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.callAfterSubmit();
      }
    );
  };

  handleStartDateChange = (event) => {
    const date = event.target.value;
    const formattedDate = date ? date.replace(/-/g, "") : null;
    this.setState({ selectedStartDate: formattedDate },
      () => {
        this.callAfterSubmit();
      }
    )
  };

  handleEndDateChange = (event) => {
    const date = event.target.value;
    const formattedDate = date ? date.replace(/-/g, "") : null;
    this.setState({ selectedEndDate: formattedDate },
      () => {
        this.callAfterSubmit();
      }
    )
  };

  clearDateRange = () => {
    this.setState({ selectedStartDate: "", selectedEndDate: "" },
      () => {
        this.setState({ selectedStartDate: null, selectedEndDate: null },
          () => {
            this.callAfterSubmit();
          }
        );
      }
    );
  };

  handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
      this.setState(
        {
          search_term,
          isTableDataLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          this.debouncedHandleSearch();
        }
      );
    } else {
      this.setState({ search_term, searchError: true });
    }
  };

  handleSortChange = (sortColumn) => {
    const { sortColumn: currentSortColumn, sortDirection } = this.state;
    const newSortDirection =
      currentSortColumn === sortColumn && sortDirection === "asc"
        ? "desc"
        : "asc";

    this.setState(
      {
        sortColumn,
        sortDirection: newSortDirection,
        offset: 0, // Reset offset when changing sorting
        currentPage: 0,
        isTableDataLoading: true,
      },
      () => {
        this.callAfterSubmit();
      }
    );
  };

  fetchallstudent = () => {
    const { mid, lg_user_id, lg_user_table_id, form_list_id } = this.props.state;

    this.setState({ isTableDataLoading: true });

    let userType = sessionStorage.getItem("userType");
    let user_id;
    let user_table_id;

    if (userType === "parent") {
      user_id = sessionStorage.getItem("parent_group_id");
      user_table_id = sessionStorage.getItem("parent_group_user_table_id");
    } else {
      user_id = lg_user_id;
      user_table_id = lg_user_table_id;
    }

    StudentService.getAllStudentsForParent(
      mid,
      form_list_id,
      user_id,
      user_table_id,
      userType
    )
      .then((response) => {
        if (response.success) {
          this.setState({ studentlist: response.data.students });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching students. Please refresh the screen!",
            "error"
          );
        }
      })
      .catch((error) => {
        sweetStatusAlert(
          "Failed!",
          "Error fetching students. Please refresh the screen!",
          "error"
        );
      })
      .finally(() => {
        this.setState({ isTableDataLoading: false });
      });
  };

  toggleEnrollModal = (asses_id, assess_name) => {
    sweetAlertEnroll(
      "Enroll Confirmation",
      "Are you sure you want to enroll in this exam?"
    ).then((enrollConfirmed) => {
      if (enrollConfirmed) {
        this.setState({ isSpinnerLoading: true }, () => {
          this.handleSubmit(asses_id, assess_name);
        });
      }
    });
  };

  handleStudentSelect = (event) => {
    if (!event.target.value) {
      this.setState({ selectedStudent: "" });
      return;
    }
    let student = this.state.studentlist.find(
      (student) => student.user_id === parseInt(event.target.value)
    );
    this.setState({ isTableDataLoading: true });
    const { flg_list_active } = this.props.state;
    if (this.state.userType === "admin") {
      if (flg_list_active === 1) {
        StudentService.getCreateUserDetail(
          student.user_id,
          student.user_table_id,
          this.state.userType
        ).then((response) => {
          const create_user_id = response.data.user_detail[0].create_user_id;
          const create_user_table_id =
            response.data.user_detail[0].create_user_table_id;
          this.setState({
            create_user_id: create_user_id,
            create_user_table_id: create_user_table_id,
          });
        });
      }
    }
    const selectedStudent = student.user_id;
    if (selectedStudent) {
      this.setState({ selectedStudent }, () => {
        this.fetchEnrollPaperData();
      });
    }
  };

  handleSubmit = async (assessment_id, assess_name) => {
    const { selectedStudent, userType, selectedCredit } = this.state;

    const UserId = sessionStorage.getItem("manage_user_id");

    var enrolledby = "";
    var credit_id = "";

    const attempt_no = this.state.papers.find(
      (assessment) => assessment.assessment_id === assessment_id
    );

    if (userType === "student") {
      enrolledby = "Student";
    } else if (userType === "admin") {
      enrolledby = "Admin";
    } else {
      enrolledby = "Parent";
    }

    let student = this.state.studentlist.find(
      (student) => student.user_id === parseInt(selectedStudent)
    );
    if (selectedCredit) {
      credit_id = selectedCredit.credit_id
    }

    const enrolled_paper = {
      node_mid: !!this.props.state.mid ? this.props.state.mid : null,
      create_user_id:
        userType === "admin" || userType === "student"
          ? this.state.create_user_id
          : this.props.state.lg_user_id,
      create_user_table_id:
        userType === "parent"
          ? this.props.state.lg_user_table_id
          : this.state.create_user_table_id,
      enroll_user_id:
        userType === "student" ? UserId : parseInt(selectedStudent),
      assessment_id: assessment_id,
      assess_name: assess_name,
      paper_status: 0,
      enrolled_by: enrolledby,
      enroll_user_table_id: userType === "student" ? 2 : student.user_table_id,
      user_table_id: userType === "student" ? 2 : student.user_table_id,
      attempt_no: attempt_no.attempt_no,
      userType: userType,
      credit_id: credit_id,
    };

    EnrolledPaperService.enrollPaperToNode(JSON.stringify(enrolled_paper))
      .then((response) => {
        if (response.success) {
          sweetStatusAlert(
            "Success!",
            "You have successfully enrolled to past paper " + enrolled_paper.assess_name + "!",
            "success"
          );

          this.callAfterSubmit();
          this.setState({ isSpinnerLoading: false, selectedCredit: null, isCreditNotAvailable: false, isModified: false, asses_id: null, assess_name: null, showInsertModal: false });
        } else {
          sweetStatusAlert(
            "Error!",
            "Failed to enroll. You may not have enough credits. Please check your available credits!.",
            "error"
          );
          this.setState({ isSpinnerLoading: false });
        }
      })
      .catch((error) => {
        sweetStatusAlert(
          "Error!",
          "An error occurred while enrolling the student. Please try again later.",
          "error"
        );
        this.setState({ isSpinnerLoading: false });
      });
  };

  fetchEnrollPaperData = () => {
    const { selectedStudent } = this.state;
    const {
      mid,
      owner_restriction,
      lg_user_id,
      lg_user_table_id,
      user_list_table_id,
      user_list_restriction,
    } = this.props.state;

    let create_user_id =
      owner_restriction === "True" && lg_user_id ? lg_user_id : "null";
    let create_user_table_id =
      owner_restriction === "True" && lg_user_table_id
        ? lg_user_table_id
        : "null";
    let enroll_user_table_id =
      user_list_restriction === "True" && user_list_table_id
        ? user_list_table_id
        : "null";
    // let enroll_user_id = (user_list_restriction === "True" && selectedStudent) ? selectedStudent : 'null'
    let enroll_user_id =
      user_list_restriction === "True" && selectedStudent
        ? selectedStudent
        : selectedStudent;

    EnrolledPaperService.getAllEnrolledPapers(
      mid,
      create_user_id,
      create_user_table_id,
      enroll_user_id,
      enroll_user_table_id,
      this.state.userType
    )
      .then((res) => {
        this.setState({ enrolledPapers: res.data.enrolledPapers });
      })
      .finally(() => {
        this.setState({ isTableDataLoading: false });
      });
  };

  fetchAllEnrolledChildPapers = () => {
    this.setState({ isTableDataLoading: true });
    const { lg_user_id } = this.props.state;
    this.setState({ selectedStudent: lg_user_id }, () => {
      this.fetchEnrollPaperData();
    });
  };

  //New Multi Filter
  onSelectFilterMulti = (selectedItem) => {

    const { filterValues } = this.state;

    let updatedFilterValues = [...filterValues];

    const index = updatedFilterValues.findIndex(
      (item) =>
        item.filter === selectedItem.filter &&
        item[`${selectedItem.filter.toLowerCase()}_id`] === selectedItem[`${selectedItem.filter.toLowerCase()}_id`]
    );


    if (index === -1) {

      updatedFilterValues.push(selectedItem);

    } else {

      updatedFilterValues.splice(index, 1);
    }


    this.onSelectFilterMultiProcess(updatedFilterValues);
  };

  onSelectFilterMultiProcess = (filterValues) => {

    const filterMap = {
      Category: [],
      Exam_Category: [],
      Difficulty: [],
      Language: [],
      Subject: [],
      Author: [],
      Year: [],
      Term: [],
      Chapter: [],
      Grade: [],
      Status: [],
      Created_By: [],
      Teacher: [],
    };

    filterValues.forEach((val) => {
      const filterType = val.filter;
      if (filterType && filterMap.hasOwnProperty(filterType)) {
        switch (filterType) {
          case "Category":
            filterMap.Category.push(val?.category_id);
            break;
          case "Exam_Category":
            filterMap.Exam_Category.push(val?.exam_category_id);
            break;
          case "Difficulty":
            filterMap.Difficulty.push(val?.difficulty_id);
            break;
          case "Language":
            filterMap.Language.push(val?.language_id);
            break;
          case "Subject":
            filterMap.Subject.push(val?.subject_id);
            break;
          case "Author":
            filterMap.Author.push(val?.author_id);
            break;
          case "Year":
            filterMap.Year.push(val?.year_id);
            break;
          case "Term":
            filterMap.Term.push(val?.term_id);
            break;
          case "Chapter":
            filterMap.Chapter.push(val?.chapter_id);
            break;
          case "Grade":
            filterMap.Grade.push(val?.grade_id);
            break;
          case "Status":
            filterMap.Status.push(val?.status_id);
            break;
          case "Created_By":
            filterMap.Created_By.push(val?.created_by_id);
            break;
          case "Teacher":
            filterMap.Teacher.push(val?.teacher_id);
            break;
          default:
            break;
        }
      }
    });

    this.setState(
      {
        filterValues,
        selectedAuthors: filterMap.Author.length > 0 ? filterMap.Author : null,
        selectedSubjects: filterMap.Subject.length > 0 ? filterMap.Subject : null,
        selectedChapters: filterMap.Chapter.length > 0 ? filterMap.Chapter : null,
        selectedTerms: filterMap.Term.length > 0 ? filterMap.Term : null,
        selectedCategories:
          filterMap.Category.length > 0 ? filterMap.Category : null,
        selectedYears: filterMap.Year.length > 0 ? filterMap.Year : null,
        selectedLanguages:
          filterMap.Language.length > 0 ? filterMap.Language : null,
        selectedDifficulties:
          filterMap.Difficulty.length > 0 ? filterMap.Difficulty : null,
        selectedGrades: filterMap.Grade.length > 0 ? filterMap.Grade : null,
        selectedStatuses: filterMap.Status.length > 0 ? filterMap.Status : null,
        selectedExamCategories: filterMap.Exam_Category.length > 0 ? filterMap.Exam_Category : null,
        selectedTeachers: filterMap.Teacher.length > 0 ? filterMap.Teacher : null,
        selectedCreators: filterMap.Created_By.length > 0 ? filterMap.Created_By : null,
      },
      () => {
        this.getAllAssessments();
      }
    );
  };

  isParentChecked = (filterType) => {
    const filterValues = this.state.filterValues;
    const childItems = this.getChildItems(filterType);
    return (
      childItems.length > 0 &&
      childItems.every((child) =>
        filterValues.some(
          (selectedItem) =>
            selectedItem.filter === filterType &&
            selectedItem[`${filterType.toLowerCase()}_id`] ===
            child[`${filterType.toLowerCase()}_id`]
        )
      )
    );
  };

  isParentIndeterminate = (filterType) => {
    const filterValues = this.state.filterValues;
    const childItems = this.getChildItems(filterType);
    const selectedCount = childItems.filter((child) =>
      filterValues.some(
        (selectedItem) =>
          selectedItem.filter === filterType &&
          selectedItem[`${filterType.toLowerCase()}_id`] ===
          child[`${filterType.toLowerCase()}_id`]
      )
    ).length;
    return selectedCount > 0 && selectedCount < childItems.length;
  };

  handleParentCheckboxChange = (filterType, filterItems) => {
    const filterValues = [...this.state.filterValues];
    const childItems = filterItems

    const allSelected = this.isParentChecked(filterType);


    let updatedFilterValues;
    if (allSelected) {

      updatedFilterValues = filterValues.filter(
        (item) => item.filter !== filterType
      );
    } else {

      const newSelections = childItems.map((child) => ({
        filter: filterType,
        name: child.name,
        [`${filterType.toLowerCase()}_id`]: child[`${filterType.toLowerCase()}_id`],
      }));
      updatedFilterValues = [
        ...filterValues.filter((item) => item.filter !== filterType),
        ...newSelections,
      ];
    }


    this.onSelectFilterMultiProcess(updatedFilterValues);
  };

  getChildItems = (filterType) => {
    switch (filterType) {
      case "Category":
        return this.state.allCategories || [];
      case "Exam_Category":
        return this.state.allExamCategories || [];
      case "Teacher":
        return this.state.allSources || [];
      case "Created_By":
        return this.state.allCreators || [];
      case "Difficulty":
        return this.state.allDifficulties || [];
      case "Language":
        return this.state.allLanguages || [];
      case "Subject":
        return this.state.allSubjects || [];
      case "Author":
        return this.state.allAuthors || [];
      case "Year":
        return this.state.allYears || [];
      case "Grade":
        return this.state.allGrades || [];
      case "Term":
        return this.state.allTerms || [];
      case "Chapter":
        return this.state.allChapters || [];
      case "Status":
        return this.state.allAssessmentStatuses || [];
      default:
        return [];
    }
  };

  clearAllFilters = () => {
    this.setState(
      {
        filterValues: [],
        selectedAuthors: null,
        selectedSubjects: null,
        selectedChapters: null,
        selectedTerms: null,
        selectedCategories: null,
        selectedYears: null,
        selectedLanguages: null,
        selectedDifficulties: null,
        selectedGrades: null,
        selectedStatuses: null,
        selectedExamCategories: null,
        selectedCreators: null,
        selectedTeachers: null,
      },
      () => {
        this.getAllAssessments();
      }
    );
  };

  toggleAddEnrollModal = (asses_id, assess_name, grade_id) => {
    this.setState(
      (prevState) => ({
        showInsertModal: !prevState.showInsertModal, asses_id: asses_id, assess_name: assess_name, grade_id: grade_id, selectedCredit: null,
        isCreditNotAvailable: false
      }),
      () => {
        if (this.state.showInsertModal) {
          this.getAllEnrollCredits();
        }
        else {
          this.setState({ selectedCredit: null, grade_id: '' })
        }
      }
    );
  };

  handleRedirect() {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("formid", 11);
    window.location.href = currentUrl.toString();
  };

  handleChangeCredit = (event) => {
    const { name, value } = event.target;
    const { credits } = this.state;

    const selectedCredit = credits.find((credit) => credit.credit_id === parseInt(value));

    this.setState({ selectedCredit: selectedCredit, isModified: true }, () => {
      if (this.state.selectedCredit) {
        if (this.state.selectedCredit.available_credits <= 0) {
          this.setState({ isCreditNotAvailable: true })
        }
        else {
          this.setState({ isCreditNotAvailable: false })
        }
      }
      else {
        this.setState({ selectedCredit: null })
      }
    })
  };

  getAllEnrollCredits() {
    this.setState({
      is_level_price_loading: true,
      creditsLoading: true
    });

    const mid = 100;
    const { grade_id } = this.state

    const UserId = sessionStorage.getItem("manage_user_id");
    CreditService.getAllCreditsForPaperEnrollment(mid, UserId, grade_id)
      .then((res) => {
        if (res.success) {
          this.setState({ credits: res.data.credits });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching Credits. Please refresh the screen!",
            "error"
          );
        }
      })
      .finally(() => {
        this.setState({
          is_level_price_loading: false,
          creditsLoading: false
        });
      });
  }

  redirectToSubscriptions() {
    const state = {
      privilege_edit: 1,
      privilege_add: 1,
      privilege_delete: 1,
      nodeTitle: 'Subscriptions',
      mid: 100,
      main_table_id: 10,
      owner_restriction: null,
      lg_user_id: sessionStorage.getItem("manage_user_id"),
      lg_user_table_id: sessionStorage.getItem("table_log_id"),
      user_list_restriction: null
    };

    history.push({
      pathname: "/subscriptions",
      state: { ...state },
    });
  }

  render() {
    const {
      papers,
      totalPapers,
      selectedStudent,
      studentlist,
      isSpinnerLoading,
      isTableDataLoading,
      creditsLoading,
      enrolledPapers,
      limit,
      currentPage,
      editVisibility,
      addVisibility,
      isDropHidden,
      userType,
      credits,
      isCreditNotAvailable,
      selectedCredit,
      offset,
      gradeCounts,
      subjectCounts,
      languageCounts,
      examCategoryCounts,
      sourceCounts,
      authorCounts,
      categoryCounts,
      difficultyCounts,
      chapterCounts,
      yearCounts,
      termCounts,
      statusCounts,
      createdByCounts,
    } = this.state;
    const path = history.location.pathname;

    return (
      <>
        <ContentWrapper disabled={path === "/manage-search"}>
          <Card>
            <CardHeader>
              {isDropHidden ? (
                <div className="col-md-12 d-flex align-items-center dropdown px-0">
                  <div className="dropdown mb-2">
                    <Form.Group
                      as={Col}
                      md="12"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Select
                        aria-label="Select the student"
                        name="student_id"
                        value={selectedStudent}
                        onChange={this.handleStudentSelect}
                      >
                        <option
                          value=""
                          style={{ fontFamily: "Inter, sans-serif" }}
                        >
                          Select Student
                        </option>
                        {studentlist.map((student) => (
                          <option key={student.user_id} value={student.user_id}>
                            {student.data_concat}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div>
                  <div className="col-md-4 px-0">
                    {(selectedStudent || !isDropHidden) && (
                      <Form.Group
                        controlId="exampleForm.ControlInput1"
                        className="mb-2"
                      >
                        <Form.Control
                          type="text"
                          placeholder="Search"
                          onChange={this.handleSearch}
                          isInvalid={this.state.searchError}
                          className="col-md-8"
                        />
                        {this.state.searchError && (
                          <Form.Control.Feedback type="invalid">
                            Invalid input
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    )}
                  </div>
                </div>
              ) : (
                <div className="col-md-12 d-flex align-items-center dropdown px-0">
                  <Form.Group
                    controlId="exampleForm.ControlInput1"
                    className="mb-2"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Search"
                      onChange={this.handleSearch}
                      isInvalid={this.state.searchError}
                      className="col-md-8"
                    />
                    {this.state.searchError && (
                      <Form.Control.Feedback type="invalid">
                        Invalid input
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </div>
              )}
            </CardHeader>
            {isDropHidden ? (
              <CardHeader>
                {(selectedStudent || !isDropHidden) && (
                  <>
                    <div className="row mt-5 align-items-center">
                      <div className="col-md-7 px-0 filterBySec">
                        <Accordion className="filterAccordion">
                          <AccordionSummary className="filterAccordionSummary" aria-controls="panel1-content" id="panel1-header">
                            <Box
                              sx={{ display: "flex", alignItems: "center", gap: "16px" }}
                            >
                              <div className="filterpprs mr-5">
                                <FilterAltIcon />
                                &emsp;Filter&emsp;
                                <KeyboardArrowDownIcon
                                  sx={{
                                    transition: "transform 0.3s ease",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => { }}
                                />
                              </div>
                            </Box>
                            <label>
                              Start Date&nbsp;:&nbsp;{" "}
                              <input
                                type="date"
                                value={this.state.selectedStartDate?.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")}
                                onChange={this.handleStartDateChange}
                                style={{ padding: "5px", marginRight: "10px", borderRadius: "4px" }}
                              />

                            </label>

                            <label className='mr-5'>
                              End Date&nbsp;:&nbsp;{" "}
                              <input
                                type="date"
                                value={this.state.selectedEndDate?.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")}
                                onChange={this.handleEndDateChange}
                                style={{ padding: "5px", borderRadius: "4px" }}
                              />

                            </label>

                            <Tooltip title="Clear dates">
                              <IconButton onClick={() => this.clearDateRange()}>
                                <ClearIcon />
                              </IconButton>
                            </Tooltip>

                            <Chip
                              className='mr-5'
                              label={
                                <span style={{ fontSize: '1.3rem' }}>
                                  No of Papers:{" "}
                                  <strong>
                                    {this.state.isTableDataLoading ?
                                      (
                                        <CircularProgress size={16} />
                                      ) : (
                                        this.state.totalPapers
                                      )
                                    }
                                  </strong>
                                </span>
                              }
                              variant="outlined"
                              color="primary"
                            />
                          </AccordionSummary>
                          <Box className="filterCardContainer" sx={{ overflowX: "auto", whiteSpace: "nowrap", display: "flex", padding: "8px", height: '40vh' }}>

                            {CMC_ASSESSMENT_FILTERS.filter((category) => {

                              return ["Grade", "Subject", "Language", "Chapter", "Year", "Term", "Exam_Category", "Source", "Created_By", "Difficulty", "Status"].includes(category);

                            }).map((category, index) => {

                              let filterItems = [];
                              if (category === "Category") {
                                const categoryCountsMap = new Map(categoryCounts.map(([category_id, count]) => [category_id, count]));
                                filterItems = this.state.allCategories?.map((val) => ({
                                  filter: "Category",
                                  name: val.name,
                                  category_id: val.category_id,
                                  dynamic_count: categoryCountsMap.get(val.category_id) || 0,
                                }));
                              } else if (category === "Exam_Category") {
                                const examCategoryCountsMap = new Map(examCategoryCounts.map(([exam_category_id, count]) => [exam_category_id, count]));
                                filterItems = this.state.allExamCategories?.map((val) => ({
                                  filter: "Exam_Category",
                                  name: val.name,
                                  exam_category_id: val.exam_category_id,
                                  dynamic_count: examCategoryCountsMap.get(val.exam_category_id) || 0,
                                }));
                              } else if (category === "Difficulty") {
                                const difficultyCountsMap = new Map(difficultyCounts.map(([difficulty_id, count]) => [difficulty_id, count]));
                                filterItems = this.state.allDifficulties?.map((val) => ({
                                  filter: "Difficulty",
                                  name: val.difficulty_type,
                                  difficulty_id: val.difficulty_id,
                                  dynamic_count: difficultyCountsMap.get(val.difficulty_id) || 0,
                                }));
                              } else if (category === "Language") {
                                const languageCountsMap = new Map(languageCounts.map(([language_id, count]) => [language_id, count]));
                                filterItems = this.state.allLanguages?.map((val) => ({
                                  filter: "Language",
                                  name: val.language,
                                  language_id: val.language_id,
                                  dynamic_count: languageCountsMap.get(val.language_id) || 0,
                                }));
                              } else if (category === "Subject") {
                                const subjectCountsMap = new Map(subjectCounts.map(([subject_id, count]) => [subject_id, count]));
                                filterItems = this.state.allSubjects?.map((val) => ({
                                  filter: "Subject",
                                  name: val.subject,
                                  subject_id: val.subject_id,
                                  dynamic_count: subjectCountsMap.get(val.subject_id) || 0,
                                }));
                              } else if (category === "Author") {
                                const authorCountsMap = new Map(authorCounts.map(([author_id, count]) => [author_id, count]));
                                filterItems = this.state.allAuthors?.map((val) => ({
                                  filter: "Author",
                                  name: val.author,
                                  author_id: val.author_id,
                                  dynamic_count: authorCountsMap.get(val.author_id) || 0,
                                }));
                              } else if (category === "Year") {
                                const yearCountsMap = new Map(yearCounts.map(([year_id, count]) => [year_id, count]));
                                filterItems = this.state.allYears?.map((val) => ({
                                  filter: "Year",
                                  name: val.year,
                                  year_id: val.year_id,
                                  dynamic_count: yearCountsMap.get(val.year_id) || 0,
                                }));
                              } else if (category === "Grade") {
                                const gradeCountsMap = new Map(gradeCounts.map(([grade_id, count]) => [grade_id, count]));
                                filterItems = this.state.allGrades?.map((val) => ({
                                  filter: "Grade",
                                  name: val.grade,
                                  grade_id: val.grade_id,
                                  dynamic_count: gradeCountsMap.get(val.grade_id) || 0,
                                }));
                              } else if (category === "Term") {
                                const termCountsMap = new Map(termCounts.map(([term_id, count]) => [term_id, count]));
                                filterItems = this.state.allTerms?.map((val) => ({
                                  filter: "Term",
                                  name: val.term,
                                  term_id: val.term_id,
                                  dynamic_count: termCountsMap.get(val.term_id) || 0,
                                }));
                              } else if (category === "Chapter") {
                                const chapterCountsMap = new Map(chapterCounts.map(([chapter_id, count]) => [chapter_id, count]));
                                filterItems = this.state.allChapters?.map((val) => ({
                                  filter: "Chapter",
                                  name: val.chapter,
                                  chapter_id: val.chapter_id,
                                  dynamic_count: chapterCountsMap.get(val.chapter_id) || 0,
                                }));
                              } else if (category === "Status") {
                                const statusCountsMap = new Map(statusCounts.map(([status_id, count]) => [status_id, count]));
                                filterItems = this.state.allAssessmentStatuses?.map((val) => ({
                                  filter: "Status",
                                  name: val.status,
                                  status_id: val.status_id,
                                  dynamic_count: statusCountsMap.get(val.status_id) || 0,
                                }));
                              } else if (category === "Source") {
                                const sourceCountsMap = new Map(sourceCounts.map(([source_id, count]) => [source_id, count]));
                                filterItems = this.state.allSources?.map((val) => ({
                                  filter: "Source",
                                  name: val.source,
                                  source_id: val.source_id,
                                  dynamic_count: sourceCountsMap.get(val.source_id) || 0,
                                }));
                              } else if (category === "Created_By") {
                                const createdByCountsMap = new Map(createdByCounts.map(([created_by_id, count]) => [created_by_id, count]));
                                filterItems = this.state.allCreators?.map((val) => ({
                                  filter: "Created_By",
                                  name: val.first_name + " " + val.last_name,
                                  created_by_id: val.created_by_id,
                                  dynamic_count: createdByCountsMap.get(parseInt(val.created_by_id)) || 0,
                                }));
                              }

                              return (
                                <div className="filterCard" key={index} style={{ display: "inline-block", minWidth: "300px", marginRight: "16px", maxHeight: "30vh" }}>
                                  <FormControlLabel
                                    label={category}

                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "flex-start",
                                      "& .MuiFormControlLabel-label": { fontWeight: "600" },
                                    }}
                                    control={
                                      <Checkbox
                                        checked={this.isParentChecked(category)}
                                        indeterminate={this.isParentIndeterminate(category)}
                                        onChange={() => this.handleParentCheckboxChange(category, filterItems)}
                                      />
                                    }
                                  />
                                  <Box sx={{ display: "flex", flexDirection: "column", ml: 3, maxHeight: "20vh", overflowY: "auto" }}>

                                    {filterItems?.map((item) => {

                                      const isChecked = this.state.filterValues.some((selectedItem) =>
                                        selectedItem.filter === item.filter &&
                                        selectedItem[`${item.filter.toLowerCase()}_id`] === item[`${item.filter.toLowerCase()}_id`]
                                      );

                                      return (
                                        <FormControlLabel
                                          key={item[`${category.toLowerCase()}_id`]}
                                          label={`${item.name}`}
                                          //label={`${item.name} ${item.dynamic_count !== 0 ? ` (${item.dynamic_count})` : ""}`}
                                          //disabled={item.dynamic_count === 0 || this.state.isTableDataLoading}
                                          control={
                                            <Checkbox
                                              checked={isChecked}
                                              onChange={() => this.onSelectFilterMulti(item)}
                                            />
                                          }
                                        />
                                      )
                                    })}
                                  </Box>
                                </div>
                              );
                            })}
                          </Box>
                        </Accordion>
                      </div>
                    </div>
                    <div className="col-md-12 mt-5">
                      {this.state.filterValues && this.state.filterValues.length > 0 &&
                        <PaperListChips
                          filterValues={this.state.filterValues}
                          chipClick={this.onSelectFilterMulti}
                          clearAll={this.clearAllFilters}
                        />
                      }
                    </div>
                  </>
                )}
              </CardHeader>
            ) : (
              <></>
            )}

            <CardBody>
              {isSpinnerLoading && (
                <PageSpinner id="show" text="Loading, Please wait!" />
              )}
              {
                isTableDataLoading ? (
                  <PageSpinner id="show" text="Loading, Please wait!" />
                ) : selectedStudent || !isDropHidden ? (
                  <div
                    style={{
                      overflowY: "auto",
                      overflowX: "auto"
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("assess_name")}
                          >
                            Paper Title{" "}
                            {this.state.sortColumn === "assess_name" && (
                              <span>
                                {this.state.sortDirection === "asc"
                                  ? <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                  : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}
                              </span>
                            )}
                          </TableCell>
                          {userType === "admin" && <TableCell className="thead">
                            More Details
                          </TableCell>}
                          {(editVisibility || addVisibility) && (
                            <TableCell className="thead">
                              Enrollment Status
                            </TableCell>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {papers.map((paper) => {
                          const enrolledExam = enrolledPapers.find((exam) => {
                            if (userType === "student") {
                              return exam.assessment_id === paper.assessment_id;
                            }
                            return (
                              exam.assessment_id === paper.assessment_id &&
                              exam.enroll_user_id ===
                              parseInt(this.state.selectedStudent)
                            );
                          });
                          return (
                            <TableRow key={paper.id}>
                              <TableCell className="tData">
                                {paper.assess_name}
                              </TableCell>
                              {userType === "admin" && <TableCell className="tData">
                                <Button
                                  onClick={(e) => this.handleViewClick(e, paper)}
                                  className="btn btn-icon btn-primary btn-sm m-1 view-assement-btn flaticon-eye-icon"
                                  title="View Paper Details"
                                />
                              </TableCell>}
                              {(userType === "parent" ||
                                userType === "admin") &&
                                (editVisibility || addVisibility) && (
                                  <TableCell className="stu-tData">
                                    {enrolledExam ? (
                                      enrolledExam.paper_status === 0 ? (
                                        <Chip
                                          label="Pending"
                                          color="primary"
                                          style={{
                                            fontFamily: "Poppins, sans-serif",
                                          }}
                                        />
                                      ) : enrolledExam.paper_status === 1 ? (
                                        <Chip
                                          label="Approved"
                                          color="success"
                                          style={{
                                            fontFamily: "Inter, sans-serif",
                                          }}
                                        />
                                      ) : enrolledExam.paper_status === 2 ? (
                                        <Chip
                                          label="Rejected"
                                          color="error"
                                          variant="outlined"
                                          style={{
                                            fontFamily: "Poppins, sans-serif",
                                          }}
                                        />
                                      ) : (
                                        <Chip
                                          label="Not enroll"
                                          color="success"
                                          variant="outlined"
                                          style={{
                                            fontFamily: "Poppins, sans-serif",
                                          }}
                                        />
                                      )
                                    ) : (
                                      <Button
                                        className="stu-variant-class"
                                        id="modal-close-button"
                                        onClick={() =>
                                          this.toggleEnrollModal(
                                            paper.assessment_id,
                                            paper.assess_name
                                          )
                                        }
                                      >
                                        Enroll
                                      </Button>
                                    )}
                                  </TableCell>
                                )}
                              {userType === "student" &&
                                (editVisibility || addVisibility) && (
                                  <TableCell className="stu-tData">
                                    {enrolledExam ? (
                                      enrolledExam.paper_status === 0 ? (
                                        <Chip
                                          label="Pending"
                                          color="primary"
                                          style={{
                                            fontFamily: "Poppins, sans-serif",
                                          }}
                                        />
                                      ) : enrolledExam.paper_status === 1 ? (
                                        <HtmlTooltip
                                          arrow
                                          placement="top"
                                          title={
                                            // <React.Fragment>
                                            //   <Typography color="inherit">Go up to next tab <b>Enrolled Papers</b> to see the paper</Typography>
                                            // </React.Fragment>
                                            <React.Fragment>
                                              <Typography color="inherit">
                                                Select{" "}
                                                <span
                                                  onClick={() => this.handleRedirect()}
                                                  style={{
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  <b><u>Enrolled Papers</u></b>
                                                </span>{" "}
                                                tab to see the paper
                                              </Typography>
                                            </React.Fragment>
                                          }
                                        >
                                          <Chip
                                            label="Enrolled"
                                            style={{
                                              fontFamily: "Inter, sans-serif",
                                              color: "#fff",
                                              backgroundColor: "var(--maincolor-cmc)",
                                              borderColor: "transparent",
                                            }}
                                          />
                                        </HtmlTooltip>
                                      ) : enrolledExam.paper_status === 2 ? (
                                        <Chip
                                          label="Rejected"
                                          color="error"
                                          variant="outlined"
                                          style={{
                                            fontFamily: "Poppins, sans-serif",
                                          }}
                                        />
                                      ) : (
                                        <Chip
                                          label="Not enroll"
                                          color="success"
                                          variant="outlined"
                                          style={{
                                            fontFamily: "Poppins, sans-serif",
                                          }}
                                        />
                                      )
                                    ) : (
                                      <Button
                                        className="stu-variant-class"
                                        id="modal-close-button"
                                        onClick={() =>
                                          this.toggleAddEnrollModal(
                                            paper.assessment_id,
                                            paper.assess_name,
                                            paper.grade_id
                                          )
                                        }
                                      >
                                        <PlaylistAddIcon />
                                      </Button>
                                    )}
                                  </TableCell>
                                )}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                    <MaterialCustomTablePagination
                      totalCount={parseInt(totalPapers)}
                      currentPage={currentPage}
                      limit={limit}
                      handlePageChange={this.handlePageChange}
                      handleRowsPerPageChange={this.handleRowsPerPageChange}
                      handlePageOffsetChange={this.handlePageOffsetChange}
                      rowsPerPageOptions={[5, 10, 20]}
                      offset={offset}
                    />
                  </div>
                ) : null /* Render nothing if no student is selected */
              }
            </CardBody>
          </Card>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showInsertModal}
            onHide={() => this.setState({ showInsertModal: false })}
          >
            <Modal.Header closeButton>
              <Modal.Title>Select The Credit To Enroll</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="12"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Available Credit Packages*</Form.Label>
                    {creditsLoading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "25vh !important",
                        }}>
                        <Spinner animation="border" role="status">
                          <span className="sr-only">Loading...</span>
                        </Spinner>
                      </div>
                    ) : (
                      <div className="pt-2">
                        {credits.length > 0
                          ? credits.map((credit) => (
                            <Sheet
                              key={credit.credit_id}
                              variant="outlined"
                              sx={{
                                borderRadius: 'md',
                                boxShadow: 'sm',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                gap: 1.5,
                                p: 2,
                                mb: 2, // Add margin-bottom to separate each item
                                transition: 'background-color 0.3s, border-color 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                  backgroundColor: 'primary.50', // Background color change on hover
                                  boxShadow: 'md',
                                  borderColor: 'primary.500',
                                },
                              }}
                            >
                              <Radio
                                id={`credit-radio-${credit.credit_id}`}
                                name="credits"
                                value={credit.credit_id}
                                label={`${credit.level_price_name} - ${credit.type_name}`}
                                checked={this.state.selectedCredit && this.state.selectedCredit.credit_id === credit.credit_id}
                                onChange={(e) => this.handleChangeCredit(e)}
                                checkedIcon={<CheckCircleRoundedIcon />}
                                slotProps={{
                                  label: ({ checked }) => ({
                                    sx: {
                                      fontWeight: 'lg',
                                      fontSize: 'md',
                                      color: checked ? 'text.primary' : 'text.secondary',
                                    },
                                  }),
                                  action: ({ checked }) => ({
                                    sx: (theme) => ({
                                      ...(checked && {
                                        '--variant-borderWidth': '2px',
                                        '&&': {
                                          borderColor: theme.vars.palette.primary[500],
                                        },
                                      }),
                                    }),
                                  }),
                                }}
                              />
                              <span>
                                Available Credits - <b>{credit.available_credits}</b>
                              </span>
                              <span>
                                Expiration Date - <b>{TimeZoneHandler.convertTime(credit.expiration_date)}</b>
                              </span>
                              <span>
                                Paid by - <b>{credit.paid_by}</b>
                              </span>
                            </Sheet>
                          ))
                          : !this.state.is_level_price_loading && (
                            <div>
                              You need credits to enroll.
                              <br />
                              <Button
                                className="modal-btn"
                                variant="primary"
                                onClick={() => this.redirectToSubscriptions()}
                              >
                                Buy Credits
                              </Button>
                            </div>
                          )}
                      </div>
                    )}

                    <div style={{ color: "red" }}>
                      {/* {this.validator.message('level', level_id, 'required')} */}
                    </div>
                  </Form.Group>
                  {this.state.isCreditNotAvailable ? (
                    <div
                      className="col-md-6"
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "end",
                        color: "red",
                      }}
                    >
                      <p>Credits not available for enroll</p>
                    </div>
                  ) : (
                    <></>
                  )}
                </Row>

                <Modal.Footer>
                  <Button
                    className="modal-btn"
                    variant="primary"
                    style={addBtnStyle}
                    disabled={isCreditNotAvailable || selectedCredit == null}
                    onClick={() =>
                      this.toggleEnrollModal(
                        this.state.asses_id,
                        this.state.assess_name
                      )
                    }
                  >
                    Enroll
                  </Button>
                  <Button
                    className="modal-btn"
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() => this.setState({ showInsertModal: false })}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>
          <Modal
            size="lg"
            show={this.state.showDetailModal}
            onHide={this.toggleDetailModal}
          >
            <Modal.Header>
              <h5 className="modal-title">{this.state.selectedPaper?.assess_name}</h5>
              <Button variant="secondary" onClick={this.toggleDetailModal}>
                Close
              </Button>
            </Modal.Header>
            {this.state.selectedPaper && (
              <Modal.Body>
                <div className="form" id="kt_form">
                  {this.state.selectedPaper?.grade_id !== null &&
                    <>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          {gradeText} :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperGrade(this.state.selectedPaper?.grade_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {this.state.selectedPaper?.subject_id !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Subject :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperSubject(this.state.selectedPaper?.subject_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {this.state.selectedPaper?.language_id !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Language :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperLanguage(this.state.selectedPaper?.language_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {this.state.selectedPaper?.exam_category_id !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Exam Category :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperExamCategory(this.state.selectedPaper?.exam_category_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {this.state.selectedPaper?.source_id !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Source :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperSource(this.state.selectedPaper?.source_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {this.state.selectedPaper?.difficulty_id !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Difficulty :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperDifficulty(this.state.selectedPaper?.difficulty_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {this.state.selectedPaper?.chapter_id !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Chapter/Module/Unit :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperChapter(this.state.selectedPaper?.chapter_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {this.state.selectedPaper?.author_id !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Author :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperAuthor(this.state.selectedPaper?.author_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {/* {this.state.selectedPaper?.year_id !== null && 
                  <>
                    <div className="separator separator-dashed my-5"></div>
                    <div className="row">
                      <h6 className="font-weight-bolder mb-3 col-md-4">
                        Year :
                      </h6>
                      <div className="text-dark-50 line-height-lg col-md-5">
                        <div className="inline-flex full-width align-center">
                          {this.getPaperYear(this.state.selectedPaper?.year_id)}
                        </div>
                      </div>
                    </div>
                  </>
                } */}
                  {this.state.selectedPaper?.term_id !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Term/Semester :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperTerm(this.state.selectedPaper?.term_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                </div>
              </Modal.Body>
            )}
          </Modal>
        </ContentWrapper>
      </>
    );
  }
}
